import styles from './SplitAssist.module.css'
import { Button } from '@/components/Button'

export interface SplitAssistProps {
  canFillRemainder: boolean
  onSplitEqually: () => unknown
  onFillRemainder: () => unknown
}

export function SplitAssist({
  canFillRemainder,
  onSplitEqually,
  onFillRemainder,
}: SplitAssistProps) {
  return (
    <div className={styles.splitAssist}>
      <div className={styles.splitAssistMessage}>Need help splitting?</div>
      <div className={styles.splitAssistControls}>
        <Button label="Split equally" variant="text" onPress={onSplitEqually} />
        <div className={styles.splitAssistDivider}>|</div>
        <Button
          label="Fill remainder"
          variant="text"
          onPress={onFillRemainder}
          isDisabled={!canFillRemainder}
        />
      </div>
    </div>
  )
}
